import { render, staticRenderFns } from "./OfficerDetails.vue?vue&type=template&id=1daa829e"
import script from "./OfficerDetails.vue?vue&type=script&lang=js"
export * from "./OfficerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports